import script from "./WordlistView.vue?vue&type=script&setup=true&lang=js"
export * from "./WordlistView.vue?vue&type=script&setup=true&lang=js"

import "./WordlistView.vue?vue&type=style&index=0&id=688f57a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688f57a2"]])

export default __exports__